// // // // Live client websites we designed + built — used on Home, /work, and /portfolio.
// // // // Each entry powers a rich "project showcase" card with live thumbnail + visit link.

// // // export const WEBSITE_PROJECTS = [
// // //   {
// // //     slug: "rakepto",
// // //     client: "Rakepto",
// // //     industry: "EdTech · Study Abroad",
// // //     hero: "Study Abroad Consulting + University Finder",
// // //     url: "https://www.rakepto.com",
// // //     leadMagnet: "University finder — students discover their dream university in 60 seconds",
// // //     stack: ["React", "Vite", "Tailwind", "Framer Motion"],
// // //     metric: "1,500+ universities · 34 countries",
// // //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.rakepto.com/",
// // //     fallback: "https://www.rakepto.com/assets/confused1-BO_WXTKF.jpg",
// // //     year: "2026",
// // //     accent: "#0B5BD3",
// // //   },
// // //   {
// // //     slug: "designhive",
// // //     client: "Sunrise Designhive",
// // //     industry: "Interior Design",
// // //     hero: "Interior design firm + Cost Calculator",
// // //     url: "https://www.designhive.in",
// // //     leadMagnet: "Quote generator — instant interior-design quotes by room type & carpet area",
// // //     stack: ["Next.js", "Tailwind", "Framer Motion"],
// // //     metric: "₹900/sqft onwards · modular interiors",
// // //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.designhive.in/",
// // //     fallback: "https://images.unsplash.com/photo-1615873968403-89e068629265?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //     year: "2025",
// // //     accent: "#8B4513",
// // //   },
// // //   {
// // //     slug: "rrl-builders",
// // //     client: "RRL Builders & Developers",
// // //     industry: "Real Estate · Construction",
// // //     hero: "Premium real estate — apartment showcase + brochure lead-magnet",
// // //     url: "https://rrlbuildersanddevelopers.com",
// // //     leadMagnet: "Brochure download — instant PDF with floor plans, pricing, amenities",
// // //     stack: ["Next.js", "Tailwind", "Cloudinary"],
// // //     metric: "6+ projects · 200% appreciation · Times RE Icon Award 2025",
// // //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://rrlbuildersanddevelopers.com/",
// // //     fallback: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //     year: "2025",
// // //     accent: "#134E35",
// // //   },
// // //   {
// // //     slug: "bangalore-institutions",
// // //     client: "Bangalore Institutions (BIMSR)",
// // //     industry: "Higher Education",
// // //     hero: "University site — admission funnel + scholarship calculator",
// // //     url: "https://www.bangaloreinstitutions.org",
// // //     leadMagnet: "Admission enquiry — program-wise eligibility + fee calculator with 0% EMI check",
// // //     stack: ["Next.js", "Tailwind"],
// // //     metric: "100+ students placed · 1,000+ hiring partners",
// // //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.bangaloreinstitutions.org/",
// // //     fallback: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //     year: "2025",
// // //     accent: "#7C3AED",
// // //   },
// // //   {
// // //     slug: "collegepedia",
// // //     client: "CollegePedia",
// // //     industry: "EdTech · Student Recruitment",
// // //     hero: "Student-recruitment agency — partnership & placement platform",
// // //     url: "https://collegepedia.vercel.app",
// // //     leadMagnet: "Institution partnership form — universities request a co-branded campaign in 24h",
// // //     stack: ["Next.js 14", "Tailwind", "Vercel"],
// // //     metric: "1,000+ students placed · 95% placement rate",
// // //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://collegepedia.vercel.app/",
// // //     fallback: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //     year: "2025",
// // //     accent: "#059669",
// // //   },
// // //   {
// // //     slug: "D Grocer's",
// // //     client: "D Grocer's",
// // //     industry: "E-commerce · Grocery",
// // //     hero: "Grocery store e-commerce site with category browsing and repeat-order flows",
// // //     url: "https://dgrocer.in/",
// // //     leadMagnet: "Weekly offers catalogue with WhatsApp enquiry and cart handoff",
// // //     stack: ["React", "Commerce", "WhatsApp"],
// // //     metric: "E-commerce · Mobile-ready",
// // //     thumb: "https://ik.imagekit.io/j0xzq9pns/groceries/D-GROCER-Premium-Dry-Fruits-Gift-Boxes-06-05-2026_10_32_AM.png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //     fallback: "https://ik.imagekit.io/j0xzq9pns/groceries/D-GROCER-Premium-Dry-Fruits-Gift-Boxes-06-05-2026_10_32_AM.png&ixlib=rb-4.1.0&q=85&w=1200",
// // //     year: "2026",
// // //     accent: "#F5C400",
// // //   },
// // //   // {
// // //   //   slug: "water-treatment",
// // //   //   client: "Water Treatment Plant",
// // //   //   industry: "Industrial · Water",
// // //   //   hero: "Industrial website for water treatment solutions, enquiries, and service categories",
// // //   //   url: "https://example.com/water-treatment",
// // //   //   leadMagnet: "Plant requirement form for capacity, location, and treatment type",
// // //   //   stack: ["React", "SEO", "Lead Forms"],
// // //   //   metric: "B2B enquiries · Industrial SEO",
// // //   //   thumb: "https://images.unsplash.com/photo-1527100673774-cce25eafaf7f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //   //   fallback: "https://images.unsplash.com/photo-1527100673774-cce25eafaf7f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //   //   year: "2026",
// // //   //   accent: "#0EA5E9",
// // //   // },
// // //   // {
// // //   //   slug: "auto-showroom",
// // //   //   client: "Automobile Showroom",
// // //   //   industry: "Automobile Industry",
// // //   //   hero: "Auto showroom landing experience for enquiries, offers, and test-drive bookings",
// // //   //   url: "https://example.com/auto-showroom",
// // //   //   leadMagnet: "Test-drive booking form with model, branch, and preferred slot",
// // //   //   stack: ["Landing Page", "Meta Ads", "CRM"],
// // //   //   metric: "Test-drive funnel · CRM-ready",
// // //   //   thumb: "https://images.unsplash.com/photo-1562141961-04d853f3b4e2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //   //   fallback: "https://images.unsplash.com/photo-1562141961-04d853f3b4e2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // //   //   year: "2026",
// // //   //   accent: "#F97316",
// // //   // },
// // // ];

// // // export const CREATIVE_PORTFOLIO = {
// // //   categories: [
// // //     { key: "all", label: "All Work" },
// // //     { key: "brand", label: "Brand Identity" },
// // //     { key: "social", label: "Social & Reels" },
// // //     { key: "ads", label: "Ad Creatives" },
// // //     { key: "print", label: "Print & OOH" },
// // //     { key: "motion", label: "Motion / Video" },
// // //   ],
// // //   items: [
// // //     // Brand Identity
// // //     { cat: "brand", title: "Sunrise Designhive — Brand system", client: "Designhive", img: "https://images.unsplash.com/photo-1634224143538-ce0221abf732?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200", span: "md:col-span-2 md:row-span-2" },
// // //     { cat: "brand", title: "Rakepto — Logo & identity", client: "Rakepto", img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "brand", title: "RRL — Visual system", client: "RRL Builders", img: "https://images.unsplash.com/photo-1618005182384-5c39e8a6e64c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "brand", title: "CollegePedia — Identity", client: "CollegePedia", img: "https://images.unsplash.com/photo-1561070791-2526d30994b8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     // Social / Reels
// // //     { cat: "social", title: "Diwali festival reel series", client: "Craftroots", img: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "social", title: "Instagram carousel suite", client: "Designhive", img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "social", title: "Abroad-study reels playbook", client: "Rakepto", img: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900", span: "md:col-span-2" },
// // //     { cat: "social", title: "Property walkthrough reels", client: "RRL Builders", img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     // Ad creatives
// // //     { cat: "ads", title: "Meta ad suite — 24 variants", client: "Motobay", img: "https://images.unsplash.com/photo-1556333720-fd197b661343?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900", span: "md:col-span-2 md:row-span-2" },
// // //     { cat: "ads", title: "PMax creative library", client: "Craftroots", img: "https://images.unsplash.com/photo-1753161029114-857c9f494ccd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "ads", title: "Launch-week Meta set", client: "Arina & Co.", img: "https://images.unsplash.com/photo-1690489965043-ec15758cce71?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "ads", title: "Lead-gen static suite", client: "BIMSR", img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // // // {
// // // //   cat: "ads",
// // // //   title: "NC216 Roadside Billboard Campaign",
// // // //   client: "RRL Builders & Developers",
// // // //   img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu.png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // // // },
// // // // {
// // // //   cat: "ads",
// // // //   title: "NC216 Retail Frontage Banner",
// // // //   client: "RRL Builders & Developers",
// // // //   img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // // // },
// // // {
// // //   cat: "ads",
// // //   title: "NC216 Digital Outdoor Creative",
// // //   client: "RRL Builders & Developers",
// // //   img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // // },
// // // {
// // //   cat: "ads",
// // //   title: "NC216 Site Hoarding Design",
// // //   client: "RRL Builders & Developers",
// // //   img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(3).png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // // },
// // //     // Print & OOH
// // //     { cat: "print", title: "Outer Ring Road hoarding — 40ft", client: "RRL Builders & Developers", img: "https://images.unsplash.com/photo-1572177812156-58036aae439c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200", span: "md:col-span-2" },
// // //     { cat: "print", title: "Metro station branding — 12 stations", client: "Motobay", img: "https://images.unsplash.com/photo-1519817650390-64a93db51149?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "print", title: "Diwali newspaper spread", client: "Craftroots", img: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" },
// // //     { cat: "print", title: "Storefront window — 3 stores", client: "Arina & Co.", img: "https://images.unsplash.com/photo-1555421689-491a97ff2040?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     {
// // //   cat: "print",
// // //   title: "NC216 Roadside Billboard Campaign",
// // //   client: "RRL Builders & Developers",
// // //   img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",

// // // },
// // // {
// // //   cat: "print",
// // //   title: "NC216 Retail Frontage Banner",
// // //   client: "RRL Builders & Developers",
// // //   img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu.png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",

// // // },
// // // // {
// // // //   cat: "print",
// // // //   title: "NC216 Digital Outdoor Creative",
// // // //   client: "RRL Builders & Developers",
// // // //   img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // // // },
// // // // {
// // // //   cat: "print",
// // // //   title: "NC216 Site Hoarding Design",
// // // //   client: "RRL Builders & Developers",
// // // //   img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(3).png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// // // // },
// // //     // Motion / Video
// // //     { cat: "motion", title: "Launch film — RRL Builders & Developers", client: "RRL Builders & Developers", img: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200", span: "md:col-span-2 md:row-span-2" },
// // //     { cat: "motion", title: "Walkthrough animation — RRL Palacio", client: "RRL Builders", img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "motion", title: "Brand film — CollegePedia", client: "CollegePedia", img: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //     { cat: "motion", title: "Motion reels — Designhive factory", client: "Designhive", img: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// // //   ],
// // // };
// // // Live client websites we designed + built — used on Home, /work, and /portfolio.
// // export const WEBSITE_PROJECTS = [
// //   {
// //     slug: "rakepto",
// //     client: "Rakepto",
// //     industry: "EdTech · Study Abroad",
// //     hero: "Study Abroad Consulting + University Finder",
// //     url: "https://www.rakepto.com",
// //     leadMagnet: "University finder — students discover their dream university in 60 seconds",
// //     stack: ["React", "Vite", "Tailwind", "Framer Motion"],
// //     metric: "1,500+ universities · 34 countries",
// //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.rakepto.com/",
// //     fallback: "https://www.rakepto.com/assets/confused1-BO_WXTKF.jpg",
// //     year: "2026",
// //     accent: "#0B5BD3",
// //   },
// //   {
// //     slug: "designhive",
// //     client: "Sunrise Designhive",
// //     industry: "Interior Design",
// //     hero: "Interior design firm + Cost Calculator",
// //     url: "https://www.designhive.in",
// //     leadMagnet: "Quote generator — instant interior-design quotes by room type & carpet area",
// //     stack: ["Next.js", "Tailwind", "Framer Motion"],
// //     metric: "₹900/sqft onwards · modular interiors",
// //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.designhive.in/",
// //     fallback: "https://images.unsplash.com/photo-1615873968403-89e068629265?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// //     year: "2025",
// //     accent: "#8B4513",
// //   },
// //   {
// //     slug: "rrl-builders",
// //     client: "RRL Builders & Developers",
// //     industry: "Real Estate · Construction",
// //     hero: "Premium real estate — apartment showcase + brochure lead-magnet",
// //     url: "https://rrlbuildersanddevelopers.com",
// //     leadMagnet: "Brochure download — instant PDF with floor plans, pricing, amenities",
// //     stack: ["Next.js", "Tailwind", "Cloudinary"],
// //     metric: "6+ projects · 200% appreciation · Times RE Icon Award 2025",
// //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://rrlbuildersanddevelopers.com/",
// //     fallback: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// //     year: "2025",
// //     accent: "#134E35",
// //   },
// //   {
// //     slug: "bangalore-institutions",
// //     client: "Bangalore Institutions (BIMSR)",
// //     industry: "Higher Education",
// //     hero: "University site — admission funnel + scholarship calculator",
// //     url: "https://www.bangaloreinstitutions.org",
// //     leadMagnet: "Admission enquiry — program-wise eligibility + fee calculator with 0% EMI check",
// //     stack: ["Next.js", "Tailwind"],
// //     metric: "100+ students placed · 1,000+ hiring partners",
// //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.bangaloreinstitutions.org/",
// //     fallback: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// //     year: "2025",
// //     accent: "#7C3AED",
// //   },
// //   {
// //     slug: "collegepedia",
// //     client: "CollegePedia",
// //     industry: "EdTech · Student Recruitment",
// //     hero: "Student-recruitment agency — partnership & placement platform",
// //     url: "https://collegepedia.vercel.app",
// //     leadMagnet: "Institution partnership form — universities request a co-branded campaign in 24h",
// //     stack: ["Next.js 14", "Tailwind", "Vercel"],
// //     metric: "1,000+ students placed · 95% placement rate",
// //     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://collegepedia.vercel.app/",
// //     fallback: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// //     year: "2025",
// //     accent: "#059669",
// //   },
// //   {
// //     slug: "d-grocers",
// //     client: "D Grocer's",
// //     industry: "E-commerce · Grocery",
// //     hero: "Grocery store e-commerce site with category browsing and repeat-order flows",
// //     url: "https://dgrocer.in/",
// //     leadMagnet: "Weekly offers catalogue with WhatsApp enquiry and cart handoff",
// //     stack: ["React", "Commerce", "WhatsApp"],
// //     metric: "E-commerce · Mobile-ready",
// //     thumb: "https://ik.imagekit.io/j0xzq9pns/groceries/D-GROCER-Premium-Dry-Fruits-Gift-Boxes-06-05-2026_10_32_AM.png?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
// //     fallback: "https://ik.imagekit.io/j0xzq9pns/groceries/D-GROCER-Premium-Dry-Fruits-Gift-Boxes-06-05-2026_10_32_AM.png",
// //     year: "2026",
// //     accent: "#F5C400",
// //   },
// // ];

// // // ─────────────────────────────────────────────────────────
// // // DESIGN JOURNEY DATA
// // // Organised as: design (soft copy) → mockup → real install
// // // ─────────────────────────────────────────────────────────

// // /**
// //  * HOARDINGS & BANNERS
// //  * Each item has a type: "design" | "mockup" | "real"
// //  * and an aspect: "portrait" | "landscape" | "square"
// //  */
// // export const HOARDINGS = [
// //   // ── NC216 Campaign ───────────────────────────────
// //   {
// //     id: "nc216-design",
// //     type: "design",
// //     label: "Design",
// //     client: "RRL Builders & Developers",
// //     project: "NC216 — EOI Launch Poster",
// //     caption: "Launch poster — EOI window, 46L onwards, 2 & 3 BHK @ Sarjapura",
// //     aspect: "portrait",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_43_PM",
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png",
// //   },
// //   {
// //     id: "nc216-mockup",
// //     type: "mockup",
// //     label: "Mockup",
// //     client: "RRL Builders & Developers",
// //     project: "NC216 — Bifold Brochure Mockup",
// //     caption: "Bifold brochure mockup — how the print piece sits in hand",
// //     aspect: "landscape",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_44_PM",
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png",
// //   },
// //   {
// //     id: "nc216-standee",
// //     type: "real",
// //     label: "Installed",
// //     client: "RRL Builders & Developers",
// //     project: "NC216 — Office Standee",
// //     caption: "Standee installed at RRL sales office — Discussion Room corridor, Sarjapura",
// //     aspect: "portrait",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_44_PM__1_",
// //     remoteImg: null,
// //   },
// //   {
// //     id: "nc216-billboard",
// //     type: "real",
// //     label: "Live Billboard",
// //     client: "RRL Builders & Developers",
// //     project: "NC216 — Highway Hoarding",
// //     caption: "40ft hoarding live at Mallenahalli, Sarjapura Road — June 2026",
// //     aspect: "landscape",
// //     imgKey: "rrl-portfolio2",
// //     remoteImg: null,
// //   },
// //   // ── RRL Multi-project Campaign ───────────────────
// //   {
// //     id: "rrl-flyer-design",
// //     type: "design",
// //     label: "Design",
// //     client: "RRL Builders & Developers",
// //     project: "Portfolio Flyer — 3 Projects",
// //     caption: "Multi-project flyer: Nature Wood, Palacio, Palm Altezze — 46L to 98L",
// //     aspect: "portrait",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_44_PM__2_",
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu.png",
// //   },
// //   {
// //     id: "rrl-expo-install",
// //     type: "real",
// //     label: "Event Install",
// //     client: "RRL Builders & Developers",
// //     project: "NC216 — Property Expo Setup",
// //     caption: "Live at property expo — standee + partner banner + NC216 scale model",
// //     aspect: "landscape",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_45_PM",
// //     remoteImg: null,
// //   },
// //   // ── Palm Altezze Pole Signs ──────────────────────
// //   {
// //     id: "palm-altezze-pole-a",
// //     type: "real",
// //     label: "Pole Sign",
// //     client: "RRL Builders & Developers",
// //     project: "Palm Altezze — Lit Pole Hoarding",
// //     caption: "Backlit pole sign, Varthur — 2 & 3 BHK from 98L (night shot)",
// //     aspect: "portrait",
// //     imgKey: "rrl-portfolio",
// //     remoteImg: null,
// //   },
// //   {
// //     id: "palm-altezze-pole-b",
// //     type: "real",
// //     label: "Pole Sign",
// //     client: "RRL Builders & Developers",
// //     project: "Palm Altezze — Directional Pole (50% UDS)",
// //     caption: "Directional pole sign with UDS call-out — street-level visibility",
// //     aspect: "portrait",
// //     imgKey: "rrl-portfolio1",
// //     remoteImg: null,
// //   },
// //   // ── Rakepto Signage ──────────────────────────────
// //   {
// //     id: "rakepto-van-mockup",
// //     type: "mockup",
// //     label: "Mockup",
// //     client: "Rakepto",
// //     project: "Container / Van Branding",
// //     caption: "3D van wrap mockup — Rakepto brand across a full shipping container",
// //     aspect: "landscape",
// //     imgKey: "rakepto1",
// //     remoteImg: null,
// //   },
// //   {
// //     id: "rakepto-fascia-real",
// //     type: "real",
// //     label: "Installed",
// //     client: "Rakepto",
// //     project: "Shop Fascia — Kasavanahalli",
// //     caption: "Installed fascia at Rakepto office, off Sarjapura Main Road",
// //     aspect: "landscape",
// //     imgKey: "rakepto2",
// //     remoteImg: null,
// //   },
// // ];

// // /**
// //  * PRINTABLES
// //  * Brochures, pamphlets, flyers
// //  */
// // export const PRINTABLES = [
// //   {
// //     id: "nc216-launch-brochure",
// //     client: "RRL Builders & Developers",
// //     title: "NC216 Launch Poster / Brochure",
// //     type: "Brochure · A4",
// //     caption: "EOI launch brochure — 46L onwards, 2 & 3 BHK at Sarjapura",
// //     aspect: "portrait",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_43_PM",
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png",
// //   },
// //   {
// //     id: "rrl-portfolio-pamphlet",
// //     client: "RRL Builders & Developers",
// //     title: "RRL Portfolio Pamphlet",
// //     type: "Flyer · A5",
// //     caption: "All-projects pamphlet — Nature Wood, Palacio, Palm Altezze",
// //     aspect: "portrait",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_44_PM__2_",
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu.png",
// //   },
// //   {
// //     id: "nc216-bifold-open",
// //     client: "RRL Builders & Developers",
// //     title: "NC216 Bifold — Open Spread",
// //     type: "Brochure · Bifold",
// //     caption: "Print-ready bifold spread with project imagery and pricing table",
// //     aspect: "landscape",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_44_PM",
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png",
// //   },
// // ];

// // /**
// //  * SOCIAL MEDIA & AD POSTERS
// //  */
// // export const SOCIAL_ADS = [
// //   {
// //     id: "palacio-social-ad",
// //     client: "RRL Builders & Developers",
// //     title: "Palacio — Ready to Move In",
// //     type: "Social Media · Square",
// //     platform: "Meta / Instagram",
// //     caption: "Palacio launch ad — 2 & 3 BHK with interiors, ready to move",
// //     aspect: "square",
// //     imgKey: "WhatsApp_Image_2026-06-27_at_12_49_45_PM__1_",
// //     remoteImg: null,
// //   },
// //   {
// //     id: "rakepto-study-abroad",
// //     client: "Rakepto",
// //     title: "Study Abroad — Free Flight Offer",
// //     type: "Social Media · Square",
// //     platform: "Meta / Facebook",
// //     caption: "Study Abroad campaign poster — free flight ticket special offer",
// //     aspect: "square",
// //     imgKey: "rakepto3",
// //     remoteImg: null,
// //   },
// //   {
// //     id: "nc216-digital-outdoor",
// //     client: "RRL Builders & Developers",
// //     title: "NC216 — Digital Outdoor Creative",
// //     type: "OOH · Digital Screen",
// //     platform: "Digital Hoarding",
// //     caption: "NC216 digital outdoor creative — dramatic reveal concept",
// //     aspect: "portrait",
// //     imgKey: null,
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png",
// //   },
// //   {
// //     id: "nc216-site-hoarding",
// //     client: "RRL Builders & Developers",
// //     title: "NC216 — Site Hoarding",
// //     type: "OOH · Site Hoarding",
// //     platform: "On-site",
// //     caption: "NC216 site hoarding design for construction site boundary",
// //     aspect: "portrait",
// //     imgKey: null,
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(3).png",
// //   },
// //   {
// //     id: "nc216-roadside",
// //     client: "RRL Builders & Developers",
// //     title: "NC216 — Roadside Billboard Creative",
// //     type: "OOH · Billboard",
// //     platform: "Outdoor",
// //     caption: "Roadside billboard campaign creative for major arterial roads",
// //     aspect: "landscape",
// //     imgKey: null,
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png",
// //   },
// //   {
// //     id: "nc216-retail-banner",
// //     client: "RRL Builders & Developers",
// //     title: "NC216 — Retail Frontage Banner",
// //     type: "Print · Banner",
// //     platform: "Retail / Showroom",
// //     caption: "Retail frontage banner — site entrance and partner offices",
// //     aspect: "landscape",
// //     imgKey: null,
// //     remoteImg: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu.png",
// //   },
// // ];

// // // Legacy creative gallery — kept for backward compat
// // export const CREATIVE_PORTFOLIO = {
// //   categories: [
// //     { key: "all", label: "All Work" },
// //     { key: "brand", label: "Brand Identity" },
// //     { key: "social", label: "Social & Reels" },
// //     { key: "ads", label: "Ad Creatives" },
// //     { key: "print", label: "Print & OOH" },
// //     { key: "motion", label: "Motion / Video" },
// //   ],
// //   items: [
// //     { cat: "brand", title: "Sunrise Designhive — Brand system", client: "Designhive", img: "https://images.unsplash.com/photo-1634224143538-ce0221abf732?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200", span: "md:col-span-2 md:row-span-2" },
// //     { cat: "brand", title: "Rakepto — Logo & identity", client: "Rakepto", img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "brand", title: "RRL — Visual system", client: "RRL Builders", img: "https://images.unsplash.com/photo-1618005182384-5c39e8a6e64c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "brand", title: "CollegePedia — Identity", client: "CollegePedia", img: "https://images.unsplash.com/photo-1561070791-2526d30994b8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "social", title: "Diwali festival reel series", client: "Craftroots", img: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "social", title: "Instagram carousel suite", client: "Designhive", img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "social", title: "Abroad-study reels playbook", client: "Rakepto", img: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900", span: "md:col-span-2" },
// //     { cat: "social", title: "Property walkthrough reels", client: "RRL Builders", img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "ads", title: "Meta ad suite — 24 variants", client: "Motobay", img: "https://images.unsplash.com/photo-1556333720-fd197b661343?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900", span: "md:col-span-2 md:row-span-2" },
// //     { cat: "ads", title: "PMax creative library", client: "Craftroots", img: "https://images.unsplash.com/photo-1753161029114-857c9f494ccd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "ads", title: "Launch-week Meta set", client: "Arina & Co.", img: "https://images.unsplash.com/photo-1690489965043-ec15758cce71?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "ads", title: "Lead-gen static suite", client: "BIMSR", img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "ads", title: "NC216 Digital Outdoor Creative", client: "RRL Builders & Developers", img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png" },
// //     { cat: "ads", title: "NC216 Site Hoarding Design", client: "RRL Builders & Developers", img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(3).png" },
// //     { cat: "print", title: "Outer Ring Road hoarding — 40ft", client: "RRL Builders & Developers", img: "https://images.unsplash.com/photo-1572177812156-58036aae439c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200", span: "md:col-span-2" },
// //     { cat: "print", title: "Metro station branding — 12 stations", client: "Motobay", img: "https://images.unsplash.com/photo-1519817650390-64a93db51149?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "print", title: "Diwali newspaper spread", client: "Craftroots", img: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" },
// //     { cat: "print", title: "Storefront window — 3 stores", client: "Arina & Co.", img: "https://images.unsplash.com/photo-1555421689-491a97ff2040?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "print", title: "NC216 Roadside Billboard Campaign", client: "RRL Builders & Developers", img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png" },
// //     { cat: "print", title: "NC216 Retail Frontage Banner", client: "RRL Builders & Developers", img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu.png" },
// //     { cat: "motion", title: "Launch film — RRL Builders & Developers", client: "RRL Builders & Developers", img: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200", span: "md:col-span-2 md:row-span-2" },
// //     { cat: "motion", title: "Walkthrough animation — RRL Palacio", client: "RRL Builders", img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "motion", title: "Brand film — CollegePedia", client: "CollegePedia", img: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //     { cat: "motion", title: "Motion reels — Designhive factory", client: "Designhive", img: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900" },
// //   ],
// // };

// // Live client websites
// export const WEBSITE_PROJECTS = [
//   {
//     slug: "rakepto",
//     client: "Rakepto",
//     industry: "EdTech · Study Abroad",
//     hero: "Study Abroad Consulting + University Finder",
//     url: "https://www.rakepto.com",
//     leadMagnet: "University finder — students discover their dream university in 60 seconds",
//     stack: ["React", "Vite", "Tailwind", "Framer Motion"],
//     metric: "1,500+ universities · 34 countries",
//     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.rakepto.com/",
//     fallback: "https://www.rakepto.com/assets/confused1-BO_WXTKF.jpg",
//     year: "2026",
//     accent: "#0B5BD3",
//   },
//   {
//     slug: "designhive",
//     client: "Sunrise Designhive",
//     industry: "Interior Design",
//     hero: "Interior design firm + Cost Calculator",
//     url: "https://www.designhive.in",
//     leadMagnet: "Quote generator — instant interior-design quotes by room type & carpet area",
//     stack: ["Next.js", "Tailwind", "Framer Motion"],
//     metric: "₹900/sqft onwards · modular interiors",
//     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.designhive.in/",
//     fallback: "https://images.unsplash.com/photo-1615873968403-89e068629265?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
//     year: "2025",
//     accent: "#8B4513",
//   },
//   {
//     slug: "rrl-builders",
//     client: "RRL Builders & Developers",
//     industry: "Real Estate · Construction",
//     hero: "Premium real estate — apartment showcase + brochure lead-magnet",
//     url: "https://rrlbuildersanddevelopers.com",
//     leadMagnet: "Brochure download — instant PDF with floor plans, pricing, amenities",
//     stack: ["Next.js", "Tailwind", "Cloudinary"],
//     metric: "6+ projects · 200% appreciation · Times RE Icon Award 2025",
//     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://rrlbuildersanddevelopers.com/",
//     fallback: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
//     year: "2025",
//     accent: "#134E35",
//   },
//   {
//     slug: "bangalore-institutions",
//     client: "Bangalore Institutions (BIMSR)",
//     industry: "Higher Education",
//     hero: "University site — admission funnel + scholarship calculator",
//     url: "https://www.bangaloreinstitutions.org",
//     leadMagnet: "Admission enquiry — program-wise eligibility + fee calculator with 0% EMI check",
//     stack: ["Next.js", "Tailwind"],
//     metric: "100+ students placed · 1,000+ hiring partners",
//     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.bangaloreinstitutions.org/",
//     fallback: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
//     year: "2025",
//     accent: "#7C3AED",
//   },
//   {
//     slug: "collegepedia",
//     client: "CollegePedia",
//     industry: "EdTech · Student Recruitment",
//     hero: "Student-recruitment agency — partnership & placement platform",
//     url: "https://collegepedia.vercel.app",
//     leadMagnet: "Institution partnership form — universities request a co-branded campaign in 24h",
//     stack: ["Next.js 14", "Tailwind", "Vercel"],
//     metric: "1,000+ students placed · 95% placement rate",
//     thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://collegepedia.vercel.app/",
//     fallback: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
//     year: "2025",
//     accent: "#059669",
//   },
//   {
//     slug: "d-grocers",
//     client: "D Grocer's",
//     industry: "E-commerce · Grocery",
//     hero: "Grocery store e-commerce site with category browsing and repeat-order flows",
//     url: "https://dgrocer.in/",
//     leadMagnet: "Weekly offers catalogue with WhatsApp enquiry and cart handoff",
//     stack: ["React", "Commerce", "WhatsApp"],
//     metric: "E-commerce · Mobile-ready",
//     thumb: "https://ik.imagekit.io/j0xzq9pns/groceries/D-GROCER-Premium-Dry-Fruits-Gift-Boxes-06-05-2026_10_32_AM.png",
//     fallback: "https://ik.imagekit.io/j0xzq9pns/groceries/D-GROCER-Premium-Dry-Fruits-Gift-Boxes-06-05-2026_10_32_AM.png",
//     year: "2026",
//     accent: "#F5C400",
//   },
// ];

// // ─────────────────────────────────────────────────────────
// // IMAGE URL CONSTANTS  (ImageKit CDN)
// // ─────────────────────────────────────────────────────────
// const IK = "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio";

// // Every filename exactly as uploaded to ImageKit
// const IMGS = {
//   // NC216 vertical launch poster  (portrait ~9:16)
//   nc216Poster:    `${IK}/WhatsApp%20Image%202026-06-27%20at%2012.49.43%20PM.jpeg`,
//   // NC216 bifold brochure mockup on white table  (landscape ~4:3)
//   nc216Bifold:    `${IK}/WhatsApp%20Image%202026-06-27%20at%2012.49.44%20PM.jpeg`,
//   // Office standee real photo at Discussion Room  (portrait)
//   nc216Standee:   `${IK}/WhatsApp%20Image%202026-06-27%20at%2012.49.44%20PM%20(1).jpeg`,
//   // RRL multi-project portfolio flyer  (portrait)
//   rrlFlyer:       `${IK}/WhatsApp%20Image%202026-06-27%20at%2012.49.44%20PM%20(2).jpeg`,
//   // Property expo wide shot with scale model  (landscape)
//   rrlExpo:        `${IK}/WhatsApp%20Image%202026-06-27%20at%2012.49.45%20PM.jpeg`,
//   // Palacio social media ad — 2&3 BHK ready to move  (square)
//   palacioAd:      `${IK}/WhatsApp%20Image%202026-06-27%20at%2012.49.45%20PM%20(1).jpeg`,
//   // Palm Altezze backlit pole sign, Varthur  (portrait)
//   palmPoleLit:    `${IK}/rrl-portfolio.jpeg`,
//   // Palm Altezze dark pole sign with 50% UDS  (portrait)
//   palmPoleUDS:    `${IK}/rrl-portfolio1.jpeg`,
//   // NC216 highway billboard, Mallenahalli  (landscape)
//   nc216Billboard: `${IK}/rrl-portfolio2.jpeg`,
//   // Rakepto container/van branding 3D mockup  (landscape)
//   rakeptoVan:     `${IK}/rakepto1.jpeg`,
//   // Rakepto shop fascia real install  (landscape)
//   rakeptoFascia:  `${IK}/rakepto2.jpeg`,
//   // Rakepto Study Abroad social ad with free flight offer  (square)
//   rakeptoAd:      `${IK}/rakepto3.jpeg`,
// };

// // ─────────────────────────────────────────────────────────
// // HOARDINGS & BANNERS
// // type: "design" | "mockup" | "real"
// // aspect: "portrait" | "landscape" | "square"
// // ─────────────────────────────────────────────────────────
// export const HOARDINGS = [
//   // ── NC216 EOI Campaign ───────────────────────────
//   {
//     id: "nc216-poster",
//     type: "design",
//     client: "RRL Builders & Developers",
//     project: "NC216 — EOI Launch Poster",
//     caption: "Digital artwork — EOI window open, 46L onwards, 2 & 3 BHK @ Sarjapura",
//     aspect: "portrait",
//     img: IMGS.nc216Poster,
//   },
//   {
//     id: "nc216-bifold",
//     type: "mockup",
//     client: "RRL Builders & Developers",
//     project: "NC216 — Bifold Brochure",
//     caption: "Print mockup — how the bifold brochure sits in hand before going to press",
//     aspect: "landscape",
//     img: IMGS.nc216Bifold,
//   },
//   {
//     id: "nc216-standee",
//     type: "real",
//     client: "RRL Builders & Developers",
//     project: "NC216 — Office Standee",
//     caption: "Installed at RRL sales office, Discussion Room corridor, Sarjapura",
//     aspect: "portrait",
//     img: IMGS.nc216Standee,
//   },
//   {
//     id: "nc216-billboard",
//     type: "real",
//     client: "RRL Builders & Developers",
//     project: "NC216 — Highway Billboard",
//     caption: "40ft live hoarding at Mallenahalli, Sarjapura Road — June 2026",
//     aspect: "landscape",
//     img: IMGS.nc216Billboard,
//   },

//   // ── RRL Multi-project Campaign ───────────────────
//   {
//     id: "rrl-flyer",
//     type: "design",
//     client: "RRL Builders & Developers",
//     project: "Portfolio Flyer — 3 Projects",
//     caption: "All-in-one flyer: Nature Wood · Palacio · Palm Altezze — 46L to 98L",
//     aspect: "portrait",
//     img: IMGS.rrlFlyer,
//   },
//   {
//     id: "rrl-expo",
//     type: "real",
//     client: "RRL Builders & Developers",
//     project: "Property Expo Installation",
//     caption: "Live at expo — NC216 standee, DesignHive partner banner, scale model display",
//     aspect: "landscape",
//     img: IMGS.rrlExpo,
//   },

//   // ── Palm Altezze Pole Signs ──────────────────────
//   {
//     id: "palm-pole-lit",
//     type: "real",
//     client: "RRL Builders & Developers",
//     project: "Palm Altezze — Backlit Pole Sign",
//     caption: "Backlit pole sign at Varthur — 2 & 3 BHK from 98L",
//     aspect: "portrait",
//     img: IMGS.palmPoleLit,
//   },
//   {
//     id: "palm-pole-uds",
//     type: "real",
//     client: "RRL Builders & Developers",
//     project: "Palm Altezze — Directional Pole (50% UDS)",
//     caption: "Street-level directional with UDS call-out, Varthur Road",
//     aspect: "portrait",
//     img: IMGS.palmPoleUDS,
//   },

//   // ── Rakepto Brand Signage ────────────────────────
//   {
//     id: "rakepto-van",
//     type: "mockup",
//     client: "Rakepto",
//     project: "Container / Van Branding",
//     caption: "3D wrap mockup — full Rakepto brand across a shipping container",
//     aspect: "landscape",
//     img: IMGS.rakeptoVan,
//   },
//   {
//     id: "rakepto-fascia",
//     type: "real",
//     client: "Rakepto",
//     project: "Shop Fascia — Kasavanahalli",
//     caption: "Fascia installed at Rakepto office, off Sarjapura Main Road",
//     aspect: "landscape",
//     img: IMGS.rakeptoFascia,
//   },
// ];

// // ─────────────────────────────────────────────────────────
// // PRINTABLES
// // ─────────────────────────────────────────────────────────
// export const PRINTABLES = [
//   {
//     id: "nc216-brochure",
//     client: "RRL Builders & Developers",
//     title: "NC216 Launch Brochure",
//     type: "Brochure · A4",
//     caption: "EOI launch brochure — 46L onwards, 2 & 3 BHK at Sarjapura",
//     aspect: "portrait",
//     img: IMGS.nc216Poster,
//   },
//   {
//     id: "nc216-bifold-print",
//     client: "RRL Builders & Developers",
//     title: "NC216 Bifold — Open Spread",
//     type: "Brochure · Bifold",
//     caption: "Print-ready bifold — open spread showing project imagery and pricing",
//     aspect: "landscape",
//     img: IMGS.nc216Bifold,
//   },
//   {
//     id: "rrl-pamphlet",
//     client: "RRL Builders & Developers",
//     title: "RRL Portfolio Pamphlet",
//     type: "Flyer · A5",
//     caption: "All-projects pamphlet — Nature Wood, Palacio, Palm Altezze",
//     aspect: "portrait",
//     img: IMGS.rrlFlyer,
//   },
// ];

// // ─────────────────────────────────────────────────────────
// // SOCIAL MEDIA & AD POSTERS
// // ─────────────────────────────────────────────────────────
// export const SOCIAL_ADS = [
//   // Square social posts
//   {
//     id: "palacio-ad",
//     client: "RRL Builders & Developers",
//     title: "Palacio — Ready to Move In",
//     type: "Social Media · Square",
//     platform: "Meta / Instagram",
//     caption: "Palacio launch ad — 2 & 3 BHK with interiors, ready to move",
//     aspect: "square",
//     img: IMGS.palacioAd,
//   },
//   {
//     id: "rakepto-ad",
//     client: "Rakepto",
//     title: "Study Abroad — Free Flight Offer",
//     type: "Social Media · Square",
//     platform: "Meta / Facebook",
//     caption: "Study Abroad campaign — free flight ticket special offer, IELTS · TOEFL · SAT",
//     aspect: "square",
//     img: IMGS.rakeptoAd,
//   },
//   // Landscape OOH
//   {
//     id: "nc216-roadside",
//     client: "RRL Builders & Developers",
//     title: "NC216 — Roadside Billboard Creative",
//     type: "OOH · Billboard",
//     platform: "Outdoor",
//     caption: "Billboard creative for arterial road placements around Sarjapura",
//     aspect: "landscape",
//     img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png",
//   },
//   {
//     id: "nc216-retail-banner",
//     client: "RRL Builders & Developers",
//     title: "NC216 — Retail Frontage Banner",
//     type: "Print · Banner",
//     platform: "Retail / Showroom",
//     caption: "Retail frontage banner for site entrance and partner showrooms",
//     aspect: "landscape",
//     img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu.png",
//   },
//   // Portrait digital / OOH
//   {
//     id: "nc216-digital-outdoor",
//     client: "RRL Builders & Developers",
//     title: "NC216 — Digital Outdoor",
//     type: "OOH · Digital Screen",
//     platform: "Digital Hoarding",
//     caption: "Digital screen creative — dramatic reveal concept for LED hoardings",
//     aspect: "portrait",
//     img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png",
//   },
//   {
//     id: "nc216-site-hoarding",
//     client: "RRL Builders & Developers",
//     title: "NC216 — Site Hoarding",
//     type: "OOH · Site Hoarding",
//     platform: "On-site",
//     caption: "Site boundary hoarding design for construction site perimeter",
//     aspect: "portrait",
//     img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(3).png",
//   },
// ];

// // ─────────────────────────────────────────────────────────
// // LEGACY CREATIVE GALLERY (kept for backward compat)
// // ─────────────────────────────────────────────────────────
// export const CREATIVE_PORTFOLIO = {
//   categories: [
//     { key: "all",    label: "All Work" },
//     { key: "brand",  label: "Brand Identity" },
//     { key: "social", label: "Social & Reels" },
//     { key: "ads",    label: "Ad Creatives" },
//     { key: "print",  label: "Print & OOH" },
//     { key: "motion", label: "Motion / Video" },
//   ],
//   items: [
//     { cat: "brand",  title: "Sunrise Designhive — Brand system",       client: "Designhive",             img: "https://images.unsplash.com/photo-1634224143538-ce0221abf732?w=900&q=80", span: "md:col-span-2 md:row-span-2" },
//     { cat: "brand",  title: "Rakepto — Logo & identity",               client: "Rakepto",                img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=900&q=80" },
//     { cat: "brand",  title: "RRL — Visual system",                     client: "RRL Builders",           img: "https://images.unsplash.com/photo-1618005182384-5c39e8a6e64c?w=900&q=80" },
//     { cat: "brand",  title: "CollegePedia — Identity",                 client: "CollegePedia",           img: "https://images.unsplash.com/photo-1561070791-2526d30994b8?w=900&q=80" },
//     { cat: "social", title: "Diwali festival reel series",             client: "Craftroots",             img: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=900&q=80" },
//     { cat: "social", title: "Instagram carousel suite",                client: "Designhive",             img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=900&q=80" },
//     { cat: "social", title: "Abroad-study reels playbook",             client: "Rakepto",                img: IMGS.rakeptoAd, span: "md:col-span-2" },
//     { cat: "social", title: "Property walkthrough reels",              client: "RRL Builders",           img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=80" },
//     { cat: "social", title: "Palacio — Ready to Move social ad",       client: "RRL Builders",           img: IMGS.palacioAd },
//     { cat: "ads",    title: "Meta ad suite — 24 variants",             client: "Motobay",                img: "https://images.unsplash.com/photo-1556333720-fd197b661343?w=900&q=80", span: "md:col-span-2 md:row-span-2" },
//     { cat: "ads",    title: "PMax creative library",                   client: "Craftroots",             img: "https://images.unsplash.com/photo-1753161029114-857c9f494ccd?w=900&q=80" },
//     { cat: "ads",    title: "Launch-week Meta set",                    client: "Arina & Co.",            img: "https://images.unsplash.com/photo-1690489965043-ec15758cce71?w=900&q=80" },
//     { cat: "ads",    title: "NC216 Digital Outdoor Creative",          client: "RRL Builders",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png" },
//     { cat: "ads",    title: "NC216 Site Hoarding Design",              client: "RRL Builders",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(3).png" },
//     { cat: "print",  title: "NC216 — Highway Billboard",               client: "RRL Builders",           img: IMGS.nc216Billboard, span: "md:col-span-2" },
//     { cat: "print",  title: "NC216 — Launch Brochure",                 client: "RRL Builders",           img: IMGS.nc216Poster },
//     { cat: "print",  title: "NC216 — Bifold Open Spread",              client: "RRL Builders",           img: IMGS.nc216Bifold },
//     { cat: "print",  title: "Palm Altezze — Backlit Pole Sign",        client: "RRL Builders",           img: IMGS.palmPoleLit },
//     { cat: "print",  title: "Palm Altezze — Directional Pole",         client: "RRL Builders",           img: IMGS.palmPoleUDS },
//     { cat: "print",  title: "RRL Portfolio Pamphlet",                  client: "RRL Builders",           img: IMGS.rrlFlyer },
//     { cat: "print",  title: "Rakepto — Van Branding Mockup",           client: "Rakepto",                img: IMGS.rakeptoVan },
//     { cat: "print",  title: "Rakepto — Shop Fascia Installation",      client: "Rakepto",                img: IMGS.rakeptoFascia },
//     { cat: "print",  title: "NC216 Roadside Billboard Creative",       client: "RRL Builders",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png" },
//     { cat: "motion", title: "Launch film — RRL Builders & Developers", client: "RRL Builders",           img: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1200&q=80", span: "md:col-span-2 md:row-span-2" },
//     { cat: "motion", title: "Walkthrough animation — RRL Palacio",     client: "RRL Builders",           img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=80" },
//     { cat: "motion", title: "Brand film — CollegePedia",               client: "CollegePedia",           img: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=900&q=80" },
//     { cat: "motion", title: "Motion reels — Designhive factory",       client: "Designhive",             img: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=900&q=80" },
//   ],
// };
// Live client websites
export const WEBSITE_PROJECTS = [
  {
    slug: "rakepto",
    client: "Rakepto",
    industry: "EdTech · Study Abroad",
    hero: "Study Abroad Consulting + University Finder",
    url: "https://www.rakepto.com",
    leadMagnet: "University finder — students discover their dream university in 60 seconds",
    stack: ["React", "Vite", "Tailwind", "Framer Motion"],
    metric: "1,500+ universities · 34 countries",
    thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.rakepto.com/",
    fallback: "https://www.rakepto.com/assets/confused1-BO_WXTKF.jpg",
    year: "2026",
    accent: "#0B5BD3",
  },
  {
    slug: "designhive",
    client: "Sunrise Designhive",
    industry: "Interior Design",
    hero: "Interior design firm + Cost Calculator",
    url: "https://www.designhive.in",
    leadMagnet: "Quote generator — instant interior-design quotes by room type & carpet area",
    stack: ["Next.js", "Tailwind", "Framer Motion"],
    metric: "₹900/sqft onwards · modular interiors",
    thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.designhive.in/",
    fallback: "https://images.unsplash.com/photo-1615873968403-89e068629265?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    year: "2025",
    accent: "#8B4513",
  },
  {
    slug: "nyrasunterra",
    client: "Nyra Sunterra",
    industry: "Interior Design",
    hero: "Interior design firm",
    url: "https://www.nyrasunterra.in/",
    leadMagnet: "Quote generator — instant interior-design quotes by room type & carpet area",
    stack: ["Next.js", "Tailwind", "Framer Motion"],
    metric: "₹900/sqft onwards · modular interiors",
    thumb: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image_RtmNSE7RH.png",
    fallback: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image_RtmNSE7RH.png",
    // thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.designhive.in/",
    // fallback: "https://images.unsplash.com/photo-1615873968403-89e068629265?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    year: "2025",
    accent: "#8B4513",
  },
  {
    slug: "rrl-builders",
    client: "RRL Builders & Developers",
    industry: "Real Estate · Construction",
    hero: "Premium real estate — apartment showcase + brochure lead-magnet",
    url: "https://rrlbuildersanddevelopers.com",
    leadMagnet: "Brochure download — instant PDF with floor plans, pricing, amenities",
    stack: ["Next.js", "Tailwind", "Cloudinary"],
    metric: "6+ projects · 200% appreciation · Times RE Icon Award 2025",
    thumb: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image.png",
    fallback: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image.png",
    // thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://rrlbuildersanddevelopers.com/",
    // fallback: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    year: "2025",
    accent: "#134E35",
  },
  {
    slug: "bangalore-institutions",
    client: "Bangalore Institutions (BIMSR)",
    industry: "Higher Education",
    hero: "University site — admission funnel + scholarship calculator",
    url: "https://www.bangaloreinstitutions.org",
    leadMagnet: "Admission enquiry — program-wise eligibility + fee calculator with 0% EMI check",
    stack: ["Next.js", "Tailwind"],
    metric: "100+ students placed · 1,000+ hiring partners",
    thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://www.bangaloreinstitutions.org/",
    fallback: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    year: "2025",
    accent: "#7C3AED",
  },
  {
    slug: "collegepedia",
    client: "CollegePedia",
    industry: "EdTech · Student Recruitment",
    hero: "Student-recruitment agency — partnership & placement platform",
    url: "https://collegepedia.vercel.app",
    leadMagnet: "Institution partnership form — universities request a co-branded campaign in 24h",
    stack: ["Next.js 14", "Tailwind", "Vercel"],
    metric: "1,000+ students placed · 95% placement rate",
    thumb: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image_lSE_C0vcW.png",
    fallback: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image_lSE_C0vcW.png",
    // thumb: "https://image.thum.io/get/width/1600/crop/1000/noanimate/https://collegepedia.vercel.app/",
    // fallback: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    year: "2025",
    accent: "#059669",
  },
  {
    slug: "d-grocers",
    client: "D Grocer's",
    industry: "E-commerce · Grocery",
    hero: "Ecommerce setup with custom UI and Shopify integration with dedicated CMS to control website via non-developers",
    url: "https://dgrocer.in/",
    leadMagnet: "Weekly offers catalogue with WhatsApp enquiry and cart handoff",
    stack: ["React", "Commerce", "WhatsApp"],
    metric: "E-commerce · Mobile-ready",
    thumb: "https://ik.imagekit.io/j0xzq9pns/groceries/D-GROCER-Premium-Dry-Fruits-Gift-Boxes-06-05-2026_10_32_AM.png",
    fallback: "https://ik.imagekit.io/j0xzq9pns/groceries/D-GROCER-Premium-Dry-Fruits-Gift-Boxes-06-05-2026_10_32_AM.png",
    year: "2026",
    accent: "#F5C400",
  },
];

// ─────────────────────────────────────────────────────────
// IMAGE URL CONSTANTS — exact ImageKit URLs as shared
// ─────────────────────────────────────────────────────────
const IMGS = {
  // Palm Altezze backlit pole sign, Varthur  (portrait)
  palmPoleLit:    "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/rrl-portfolio.jpeg?updatedAt=1782588137380",
  // Palm Altezze dark pole sign 50% UDS  (portrait)
  palmPoleUDS:    "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/rrl-portfolio1.jpeg?updatedAt=1782588137908",
  // Rakepto Study Abroad social ad  (square)
  rakeptoAd:      "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/rakepto3.jpeg?updatedAt=1782588138197",
  // RRL multi-project portfolio flyer  (portrait)
  rrlFlyer:       "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/WhatsApp%20Image%202026-06-27%20at%2012.49.44%20PM%20(2).jpeg?updatedAt=1782588138254",
  // Rakepto container/van branding 3D mockup  (landscape)
  rakeptoVan:     "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/rakepto1.jpeg?updatedAt=1782588138245",
  // NC216 vertical launch poster  (portrait ~9:16)
  nc216Poster:    "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/WhatsApp%20Image%202026-06-27%20at%2012.49.43%20PM.jpeg?updatedAt=1782588138294",
  // Rakepto shop fascia real install  (landscape)
  rakeptoFascia:  "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/rakepto2.jpeg?updatedAt=1782588138680",
  // Office standee real photo at Discussion Room  (portrait)
  nc216Standee:   "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/WhatsApp%20Image%202026-06-27%20at%2012.49.44%20PM%20(1).jpeg?updatedAt=1782588139351",
  // NC216 bifold brochure mockup on white table  (landscape ~4:3)
  nc216Bifold:    "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/WhatsApp%20Image%202026-06-27%20at%2012.49.44%20PM.jpeg?updatedAt=1782588139464",
  // NC216 highway billboard, Mallenahalli  (landscape)
  nc216Billboard: "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/rrl-portfolio2.jpeg?updatedAt=1782588139756",
  // Palacio social media ad — 2&3 BHK ready to move  (square)
  palacioAd:      "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/WhatsApp%20Image%202026-06-27%20at%2012.49.45%20PM%20(1).jpeg?updatedAt=1782588140014",
  // Property expo wide shot with scale model  (landscape)
  rrlExpo:        "https://ik.imagekit.io/j0xzq9pns/marketly/marketly-portfolio/WhatsApp%20Image%202026-06-27%20at%2012.49.45%20PM.jpeg?updatedAt=1782588140262",
};



// ─────────────────────────────────────────────────────────
// HOARDINGS & BANNERS
// type: "design" | "mockup" | "real"
// aspect: "portrait" | "landscape" | "square"
// ─────────────────────────────────────────────────────────
export const HOARDINGS = [
  // ── NC216 EOI Campaign ───────────────────────────
  {
    id: "nc216-poster",
    type: "design",
    client: "RRL Builders & Developers",
    project: "NC216 — EOI Launch Poster",
    caption: "Digital artwork — EOI window open, 46L onwards, 2 & 3 BHK @ Sarjapura",
    aspect: "portrait",
    img: IMGS.nc216Poster,
  },
  {
    id: "nc216-bifold",
    type: "mockup",
    client: "RRL Builders & Developers",
    project: "NC216 — Bifold Brochure",
    caption: "Print mockup — how the bifold brochure sits in hand before going to press",
    aspect: "landscape",
    img: IMGS.nc216Bifold,
  },
  {
    id: "nc216-standee",
    type: "real",
    client: "RRL Builders & Developers",
    project: "NC216 — Office Standee",
    caption: "Installed at RRL sales office, Discussion Room corridor, Sarjapura",
    aspect: "portrait",
    img: IMGS.nc216Standee,
  },
  {
    id: "nc216-billboard",
    type: "real",
    client: "RRL Builders & Developers",
    project: "NC216 — Highway Billboard",
    caption: "40ft live hoarding at Mallenahalli, Sarjapura Road — June 2026",
    aspect: "landscape",
    img: IMGS.nc216Billboard,
  },

  // ── RRL Multi-project Campaign ───────────────────
  {
    id: "rrl-flyer",
    type: "design",
    client: "RRL Builders & Developers",
    project: "Portfolio Flyer — 3 Projects",
    caption: "All-in-one flyer: Nature Wood · Palacio · Palm Altezze — 46L to 98L",
    aspect: "portrait",
    img: IMGS.rrlFlyer,
  },
  {
    id: "rrl-expo",
    type: "real",
    client: "RRL Builders & Developers",
    project: "Property Expo Installation",
    caption: "Live at expo — NC216 standee, DesignHive partner banner, scale model display",
    aspect: "landscape",
    img: IMGS.rrlExpo,
  },

  // ── Palm Altezze Pole Signs ──────────────────────
  {
    id: "palm-pole-lit",
    type: "real",
    client: "RRL Builders & Developers",
    project: "Palm Altezze — Backlit Pole Sign",
    caption: "Backlit pole sign at Varthur — 2 & 3 BHK from 98L",
    aspect: "portrait",
    img: IMGS.palmPoleLit,
  },
  {
    id: "palm-pole-uds",
    type: "real",
    client: "RRL Builders & Developers",
    project: "Palm Altezze — Directional Pole (50% UDS)",
    caption: "Street-level directional with UDS call-out, Varthur Road",
    aspect: "portrait",
    img: IMGS.palmPoleUDS,
  },

  // ── Rakepto Brand Signage ────────────────────────
  {
    id: "rakepto-van",
    type: "mockup",
    client: "Rakepto",
    project: "Container / Van Branding",
    caption: "3D wrap mockup — full Rakepto brand across a shipping container",
    aspect: "landscape",
    img: IMGS.rakeptoVan,
  },
  {
    id: "rakepto-fascia",
    type: "real",
    client: "Rakepto",
    project: "Shop Fascia — Kasavanahalli",
    caption: "Fascia installed at Rakepto office, off Sarjapura Main Road",
    aspect: "landscape",
    img: IMGS.rakeptoFascia,
  },
];

// ─────────────────────────────────────────────────────────
// PRINTABLES
// ─────────────────────────────────────────────────────────
export const PRINTABLES = [
  {
    id: "nc216-brochure",
    client: "RRL Builders & Developers",
    title: "NC216 Launch Brochure",
    type: "Brochure · A4",
    caption: "EOI launch brochure — 46L onwards, 2 & 3 BHK at Sarjapura",
    aspect: "portrait",
    img: IMGS.nc216Poster,
  },
  {
    id: "nc216-bifold-print",
    client: "RRL Builders & Developers",
    title: "NC216 Bifold — Open Spread",
    type: "Brochure · Bifold",
    caption: "Print-ready bifold — open spread showing project imagery and pricing",
    aspect: "landscape",
    img: IMGS.nc216Bifold,
  },
  {
    id: "rrl-pamphlet",
    client: "RRL Builders & Developers",
    title: "RRL Portfolio Pamphlet",
    type: "Flyer · A5",
    caption: "All-projects pamphlet — Nature Wood, Palacio, Palm Altezze",
    aspect: "portrait",
    img: IMGS.rrlFlyer,
  },
];

// ─────────────────────────────────────────────────────────
// SOCIAL MEDIA & AD POSTERS
// ─────────────────────────────────────────────────────────
export const SOCIAL_ADS = [
  // Square social posts
  {
    id: "palacio-ad",
    client: "RRL Builders & Developers",
    title: "Palacio — Ready to Move In",
    type: "Social Media · Square",
    platform: "Meta / Instagram",
    caption: "Palacio launch ad — 2 & 3 BHK with interiors, ready to move",
    aspect: "square",
    img: IMGS.palacioAd,
  },
  {
    id: "rakepto-ad",
    client: "Rakepto",
    title: "Study Abroad — Free Flight Offer",
    type: "Social Media · Square",
    platform: "Meta / Facebook",
    caption: "Study Abroad campaign — free flight ticket special offer, IELTS · TOEFL · SAT",
    aspect: "square",
    img: IMGS.rakeptoAd,
  },
  // Landscape OOH
  {
    id: "nc216-roadside",
    client: "RRL Builders & Developers",
    title: "NC216 — Roadside Billboard Creative",
    type: "OOH · Billboard",
    platform: "Outdoor",
    caption: "Billboard creative for arterial road placements around Sarjapura",
    aspect: "landscape",
    img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png",
  },
  {
    id: "nc216-retail-banner",
    client: "RRL Builders & Developers",
    title: "NC216 — Retail Frontage Banner",
    type: "Print · Banner",
    platform: "Retail / Showroom",
    caption: "Retail frontage banner for site entrance and partner showrooms",
    aspect: "landscape",
    img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu.png",
  },
  // Portrait digital / OOH
  {
    id: "nc216-digital-outdoor",
    client: "RRL Builders & Developers",
    title: "NC216 — Digital Outdoor",
    type: "OOH · Digital Screen",
    platform: "Digital Hoarding",
    caption: "Digital screen creative — dramatic reveal concept for LED hoardings",
    aspect: "portrait",
    img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png",
  },
  {
    id: "nc216-site-hoarding",
    client: "RRL Builders & Developers",
    title: "NC216 — Site Hoarding",
    type: "OOH · Site Hoarding",
    platform: "On-site",
    caption: "Site boundary hoarding design for construction site perimeter",
    aspect: "portrait",
    img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(3).png",
  },
];

// ─────────────────────────────────────────────────────────
// LEGACY CREATIVE GALLERY (kept for backward compat)
// ─────────────────────────────────────────────────────────
export const CREATIVE_PORTFOLIO = {
  categories: [
    { key: "all",    label: "All Work" },
    { key: "brand",  label: "Brand Identity" },
    { key: "social", label: "Social & Reels" },
    { key: "ads",    label: "Ad Creatives" },
    { key: "print",  label: "Print & OOH" },
    { key: "motion", label: "Motion / Video" },
  ],
  items: [
    { cat: "brand",  title: "Sunrise Designhive — Brand system",       client: "Designhive",             img: "https://images.unsplash.com/photo-1634224143538-ce0221abf732?w=900&q=80", span: "md:col-span-2 md:row-span-2" },
    { cat: "brand",  title: "Rakepto — Logo & identity",               client: "Rakepto",                img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=900&q=80" },
    { cat: "brand",  title: "RRL — Visual system",                     client: "RRL Builders",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image.png" },
    { cat: "brand",  title: "CollegePedia — Identity",                 client: "CollegePedia",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image_lSE_C0vcW.png" },
    { cat: "social", title: "Diwali festival reel series",             client: "Craftroots",             img: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=900&q=80" },
    { cat: "social", title: "Instagram carousel suite",                client: "Designhive",             img: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=900&q=80" },
    { cat: "social", title: "Abroad-study reels playbook",             client: "Rakepto",                img: IMGS.rakeptoAd, span: "md:col-span-2" },
    { cat: "social", title: "Property walkthrough reels",              client: "RRL Builders",           img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=80" },
    { cat: "social", title: "Palacio — Ready to Move social ad",       client: "RRL Builders",           img: IMGS.palacioAd },
    { cat: "ads",    title: "Meta ad suite — 24 variants",             client: "Motobay",                img: "https://images.unsplash.com/photo-1556333720-fd197b661343?w=900&q=80", span: "md:col-span-2 md:row-span-2" },
    { cat: "ads",    title: "PMax creative library",                   client: "Craftroots",             img: "https://images.unsplash.com/photo-1753161029114-857c9f494ccd?w=900&q=80" },
    { cat: "ads",    title: "Launch-week Meta set",                    client: "Arina & Co.",            img: "https://images.unsplash.com/photo-1690489965043-ec15758cce71?w=900&q=80" },
    { cat: "ads",    title: "NC216 Digital Outdoor Creative",          client: "RRL Builders",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(2).png" },
    { cat: "ads",    title: "NC216 Site Hoarding Design",              client: "RRL Builders",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(3).png" },
    { cat: "print",  title: "NC216 — Highway Billboard",               client: "RRL Builders",           img: IMGS.nc216Billboard, span: "md:col-span-2" },
    { cat: "print",  title: "NC216 — Launch Brochure",                 client: "RRL Builders",           img: IMGS.nc216Poster },
    { cat: "print",  title: "NC216 — Bifold Open Spread",              client: "RRL Builders",           img: IMGS.nc216Bifold },
    { cat: "print",  title: "Palm Altezze — Backlit Pole Sign",        client: "RRL Builders",           img: IMGS.palmPoleLit },
    { cat: "print",  title: "Palm Altezze — Directional Pole",         client: "RRL Builders",           img: IMGS.palmPoleUDS },
    { cat: "print",  title: "RRL Portfolio Pamphlet",                  client: "RRL Builders",           img: IMGS.rrlFlyer },
    { cat: "print",  title: "Rakepto — Van Branding Mockup",           client: "Rakepto",                img: IMGS.rakeptoVan },
    { cat: "print",  title: "Rakepto — Shop Fascia Installation",      client: "Rakepto",                img: IMGS.rakeptoFascia },
    { cat: "print",  title: "NC216 Roadside Billboard Creative",       client: "RRL Builders",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/Marketlu%20(1).png" },
    { cat: "motion", title: "Launch film — RRL Builders & Developers", client: "RRL Builders",           img: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1200&q=80", span: "md:col-span-2 md:row-span-2" },
    { cat: "motion", title: "Walkthrough animation — RRL Palacio",     client: "RRL Builders",           img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=80" },
    { cat: "motion", title: "Brand film — CollegePedia",               client: "CollegePedia",           img: "https://ik.imagekit.io/j0xzq9pns/marketly/company/image_lSE_C0vcW.png" },
    { cat: "motion", title: "Motion reels — Designhive factory",       client: "Designhive",             img: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=900&q=80" },
  ],
};